import {
  CaseSearchResult,
  CreditorSearchResult,
  DebtorARSearchResult,
  DebtorSearchResult,
  InvoiceSearchResult,
} from "../Types";

/**
 * @function
 * @description Arrange invoices and cases data.
 * @param {Array<any>} data - invoices or cases payload
 * @param {string} type - arrange type
 * @returns An array of arranged invoices or cases
 */
const getInvoicesAndCasesArranged = (
  data: any[],
  type: "invoice" | "case"
): InvoiceSearchResult[] | CaseSearchResult[] => {
  try {
    if (type == "invoice") {
      return data.map((item: any) => ({
        ...item,
        key: item.subCaseNo,
      }));
    } else {
      return data.map((item: any) => ({
        ...item,
        key: item.caseNo,
      }));
    }
  } catch (e) {
    return [];
  }
};

/**
 * @function
 * @description Arrange creditors.
 * @param {Array<any>} data - creditors payload
 * @returns An array of arranged creditors
 */
const getCreditorArranged = (data: any[]): CreditorSearchResult[] => {
  try {
    return data.map((creditor: any) => ({
      ...creditor,
      key: creditor.creditorEntRoleId,
    }));
  } catch (e) {
    return [];
  }
};

/**
 * @function
 * @description Arrange debtors.
 * @param {Array<any>} data - debtors payload
 * @returns An array of arranged debtors
 */
const getDebtorArranged = (data: any[]): DebtorSearchResult[] => {
  try {
    return data.map((debtor: any) => ({
      ...debtor,
      isARCollapsed: true,
      key: debtor.debtorEntNo,
      arDetails: debtor.arDetails.map((arItem: DebtorARSearchResult) => ({
        ...arItem,
        key: arItem.arNo,
        caseDetails: arItem.caseDetails.map((caseItem: any) => ({
          ...caseItem,
          key: caseItem.caseNo,
        })),
      })),
    }));
  } catch (e) {
    return [];
  }
};

export default {
  getInvoicesAndCasesArranged,
  getCreditorArranged,
  getDebtorArranged,
};
